import Routes from "./router/index";
import "./App.css"

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
